import { Paper } from '@mui/material';
import { LAYOUT } from '@/constants/layout';

interface UpFrameProps {
  title?: string;
  children?: React.ReactNode;
}

const UpFrame = ({ children }: UpFrameProps) => {
  return (
    <Paper sx={{ 
      p: LAYOUT.PADDING.MEDIUM / 8,
      display: 'flex',
      alignItems: 'center',
      width: '100%',
    }}>
      {children}
    </Paper>
  );
};

export default UpFrame; 